<template>
  <div class="text-main">
    <div class="ant-table-cell-ellipsis my-text">{{ showList.join(props.separator) || "- -" }}</div>
    <div>{{ resultList.length > 3 ? `...共${resultList.length}${props.unit}` : '' }}</div>
    <a-tooltip v-if="resultList.length > 3" :title="props.value" color="#fff" overlayClassName="my-table-tooltip">
      <span class="look-btn">查看全部</span>
    </a-tooltip>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  separator: {
    type: String,
    default: '、',
  },
  unit: {
    type: String,
    default: '个',
  },
})
const resultList = computed(() => {
  return props.value.split(props.separator).filter(ele => !!ele);
})
const showList = computed(() => {
  return resultList.value.slice(0, 3)
})
</script>
<style lang="less" scoped>
.look-btn {
  margin-left: 8px;
  color: #1890ff;
  cursor: help;
  font-size: 12px;
}

.text-main {
  display: flex;
  justify-content: start;
  overflow: hidden;

  .my-text {
    width: auto;
  }
}
</style>